// extracted by mini-css-extract-plugin
export default {"landingSection":"LandingPage_landingSection__P2unD","content":"LandingPage_content__y2x1f","ctaDiv":"LandingPage_ctaDiv__+HNiz","btnPrimary":"LandingPage_btnPrimary__6aXVL"};